import { isValidSchema } from "./util";
export class FrameDataMeta {
    constructor(id, imagepixsize, imagewidth, imageheight, imageminzoom, imagemaxzoom, imageformat, imagestructure, imagefocallength, depthmappixsize, depthmapnumdisparities, depthmapwidth, depthmapheight, depthmapminzoom, depthmapmaxzoom, depthmapformat, depthmapstructure, depthmapfocallength, tilesize, streamingdirectory, depthmapbasis, precBasis, precDisparity, precFocallength) {
        this.id = id;
        this.imagepixsize = imagepixsize;
        this.imagewidth = imagewidth;
        this.imageheight = imageheight;
        this.imageminzoom = imageminzoom;
        this.imagemaxzoom = imagemaxzoom;
        this.imageformat = imageformat;
        this.imagestructure = imagestructure;
        this.imagefocallength = imagefocallength;
        this.depthmappixsize = depthmappixsize;
        this.depthmapnumdisparities = depthmapnumdisparities;
        this.depthmapwidth = depthmapwidth;
        this.depthmapheight = depthmapheight;
        this.depthmapminzoom = depthmapminzoom;
        this.depthmapmaxzoom = depthmapmaxzoom;
        this.depthmapformat = depthmapformat;
        this.depthmapstructure = depthmapstructure;
        this.depthmapfocallength = depthmapfocallength;
        this.tilesize = tilesize;
        this.streamingdirectory = streamingdirectory;
        this.depthmapbasis = depthmapbasis;
        this.precBasis = precBasis;
        this.precDisparity = precDisparity;
        this.precFocallength = precFocallength;
    }
    static create(payload) {
        return new FrameDataMeta(payload.id, payload.imagepixsize, payload.imagewidth, payload.imageheight, payload.imageminzoom, payload.imagemaxzoom, payload.imageformat, payload.imagestructure, payload.imagefocallength, payload.depthmappixsize, payload.depthmapnumdisparities, payload.depthmapwidth, payload.depthmapheight, payload.depthmapminzoom, payload.depthmapmaxzoom, payload.depthmapformat, payload.depthmapstructure, payload.depthmapfocallength, payload.tilesize, payload.streamingdirectory, payload.depthmapbasis, payload.precBasis, payload.precDisparity, payload.precFocallength);
    }
    static isValid(payload) {
        const schema = [
            "id",
            "imagepixsize",
            "imagewidth",
            "imageheight",
            "imageminzoom",
            "imagemaxzoom",
            "imageformat",
            "imagestructure",
            "imagefocallength",
            "depthmappixsize",
            "depthmapnumdisparities",
            "depthmapwidth",
            "depthmapheight",
            "depthmapminzoom",
            "depthmapmaxzoom",
            "depthmapformat",
            "depthmapstructure",
            "depthmapfocallength",
            "tilesize",
            "streamingdirectory",
            "depthmapbasis",
            "precBasis",
            "precDisparity",
            "precFocallength",
        ];
        return isValidSchema(payload, schema);
    }
}
//# sourceMappingURL=framedatameta.js.map